import React, { memo } from 'react';
var _ref = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3C4248",
  d: "M27.167 20.297c0 3.837-3.11 6.958-6.934 6.958h-8.58c-3.823 0-6.933-3.12-6.933-6.958v-8.613c0-3.837 3.11-6.958 6.932-6.958h8.581c3.823 0 6.934 3.12 6.934 6.958v8.613zM20.233 3h-8.58C6.881 3 3 6.896 3 11.684v8.613c0 4.788 3.882 8.684 8.652 8.684h8.581c4.774 0 8.657-3.896 8.657-8.684v-8.613C28.89 6.896 25.007 3 20.233 3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ED8B00",
  d: "M18.45 13.676a2.885 2.885 0 01-3.952 1.061 2.904 2.904 0 01-1.057-3.964 2.888 2.888 0 013.952-1.063 2.912 2.912 0 011.058 3.966zm-3.53 6.386a2.886 2.886 0 01-3.951 1.061 2.905 2.905 0 01-1.057-3.964 2.888 2.888 0 013.951-1.064 2.908 2.908 0 011.057 3.967zm2.05 0a2.905 2.905 0 011.058-3.967 2.889 2.889 0 013.952 1.064 2.908 2.908 0 01-1.06 3.964 2.882 2.882 0 01-3.95-1.062z"
})));
const ForceIcon = () => {
  return _ref;
};
export default /*#__PURE__*/memo(ForceIcon);